<template lang='pug'>
  .mr-sign-in
    .sign-in-wrap.xs-f-small.max-at-tweak
      .xs-12(v-if="fbAuthed")
        .xs-1.xs-push-1
          i.fb-connected
        .xs-11.xs-push-1
          p Connected

      #sign-in-top.xs-12.text-center(v-show="view == 'signIn' || view == 'create' || view == 'checkout'")
        button.btn-link.upper.xs-6(v-on:click="view = 'signIn'" v-bind:class="{selected: view == 'signIn'}" data-mr-ass="log-in") login
        button.btn-link.upper.xs-6(v-on:click="view = 'create'" v-bind:class="{selected: view == 'create' || view == 'checkout'}" data-mr-ass="checkout-as-new") create account

      #sign-in.xs-12(v-if="view == 'signIn'")
        .timed-out.text-center(v-if="timedOut")
          p.xs-f-small.max-at-tweak Your session has timed out

        form#sign_in_form(name='sign_in_form' v-on:submit.prevent="signIn()" v-bind:class="{'form-checkout': checkout}" novalidate)
          .error-container
            p.error(v-if="signInError") {{signInError}}

            .mr-input-wrap
              mrInput(v-model="$v.signInForm.email.$model" :label="'Email'" :inputType="'email'" :v="$v.signInForm.email" :autocomplete="'username'" required="true" :dataMrAss="'sign-in-email'")

            .mr-input-wrap
              mrInput(v-if="!showPassword" v-model="$v.signInForm.password.$model" :inputType="'password'" :label="'Password'" :v="$v.signInForm.password" :autocomplete="'current-password'" required="true" :dataMrAss="'sign-in-password'")
              mrInput(v-else v-model="$v.signInForm.password.$model" :inputType="'text'" :label="'Password'" :v="$v.signInForm.password" :autocomplete='current-password' required="true" :dataMrAss="'sign-in-password'")
                button.btn-link.show-password.font-xsmall.color-black.lg-hide(type="button" v-on:click="showPassword = !showPassword") {{showPassword ? 'Hide' : 'Show'}}

          .captcha(v-show="showCaptcha == 'login'")
            captcha(v-on:captcha-response="captchaResponse = $event")
          .remember-me.text-center
            #keepMeSignedIn.checkbox
              mrInputCheckbox(v-model="keepMeSignedIn" :dataMrAss="'keep-me-signed-in'" :label="'Keep me signed in'")
              button.btn-link.color-purple.info.icon-info.font-medium(type="button" v-on:click="toggleInfo('keepMeSignedIn')")
                span.ada-tooltip toggle more info on keep me signed in

          .popup-info(v-show="showInfo == 'keepMeSignedIn'")
            p.font-xsmall Choosing "Keep me signed in" reduces the number of times you're asked to sign in. You should use this only on your personal devices.
            button.btn-link.color-purple.hide-info.font-xsmall(type="button" v-on:click="toggleInfo('keepMeSignedIn')") (Hide)

          button.mr-btn.btn-block.font-xsmall(type='submit' v-bind:disabled="$v.signInForm.$invalid" v-bind:class="{disabled: $v.signInForm.$invalid}" data-mr-ass="sign-in") log in

          .forgot-password.text-center
            button.btn-link.color-black(type="button" v-on:click="view = 'forgot'" data-mr-ass="forgot-password") Forgot Password

        .or
          p.upper or

        .facebook-sign-in.text-center
          button#facebook-sign-in.btn-link.color-purple.font-large(type="button" v-on:click="facebookSignIn")
            i.icon-facebook
            span.font-small &nbsp;Continue with Facebook

        .not-you-wrap.text-center(v-if="timedOut")
          p.not-you.xs-f-small.max-at-tweak Not you?&nbsp;
            button.btn-link.color-purple.xs-f-small.max-at-tweak(type="button" v-on:click="$root.logOut()") Log out

      #sign-up.xs-12(v-if="view == 'create' || view == 'setPassword' || view == 'checkout' || view == 'confirmationCreate'")
        .title(v-if="confirmation")
          h2.text-center.xs-f-small.max-at-tweak Make changes to your membership online anytime and more.
        form#create_account_form(name="create_account_form" v-on:submit.prevent="createAccount" novalidate)
          .error-container
            p(v-if="createError") {{createError}}

          .mr-input-wrap
            mrInput#create_account_email(v-model="$v.signInForm.email.$model" :label="'Email'" :inputType="'email'" :v="$v.signInForm.email" required="true" :dataMrAss="'create-account-email'" :disabled="code || view == 'confirmationCreate'")

          .input-error(v-if="!$v.signInForm.password.minLength")
            span.color-slate.font-xsmall Password must be at least 6 characters long.

          .mr-input-wrap
            mrInput#create_account_password(v-model="$v.signInForm.password.$model" :inputType="showPassword ? 'text' : 'password'" :label="'Password'" :v="$v.signInForm.password" :autocomplete="'new-password'" required="true" :dataMrAss="'create-account-password'" name='password')
              button.btn-link.show-password.font-xsmall.color-black(type="button" v-on:click='showPassword = !showPassword') {{showPassword ? 'Hide' : 'Show'}}

          .birthday(v-if='showBirthdayInput')
            button.btn-link.info-toggle.color-slate.font-xsmall(type="button" v-on:click="toggleInfo('birthday')")
              span.ada-tooltip toggle birthday input
              | Birthday (optional)&nbsp;
              i.icon-info.font-small.color-purple
            .popup-info(v-show="showInfo == 'birthday'")
              p.font-xsmall We love our members, so tell us your birthday and we'll surprise you with a special gift on your birthday.
              button.btn-link.color-purple.hide-info.font-xsmall(type="button" v-on:click="toggleInfo('birthday')") (Hide)

            .birthday-inputs
              .birthday-input
                dropdown(label="Month" v-model="birthdayMonth")
                  option(v-for="option in months" :value="option.value" :key="option.value") {{option.label}}
              .birthday-input
                dropdown(label="Day" v-model="birthdayDay")
                  option(v-for="option in days" :value="option.value" :key="option.value") {{option.label}}

          .checkbox.opt-in(v-if="showOptIn")
            mrInputCheckbox(v-model="optInEmail" :dataMrAss="'opt-in-email'" :label=`"Yes, I'd like exclusive offers, sneak peeks, and professional stylist tips delivered."`)

          .captcha(v-show="showCaptcha == 'create'")
            captcha(v-on:captcha-response="captchaResponse = $event")

          button.mr-btn.btn-block.font-xsmall(type="submit" v-if='!checkout' v-bind:disabled="$v.signInForm.$invalid" v-bind:class="{disabled: $v.signInForm.$invalid}" data-mr-ass="sign-up") {{confirmation ? 'sign up' : 'create account'}}

        .or(v-if="!confirmation")
          p.upper or

        .facebook-sign-in.text-center(v-if='!confirmation')
          button.btn-link.color-purple#facebook-sign-in.font-large(type="button" v-on:click="facebookSignIn")
            i.icon-facebook
            span.font-small &nbsp;Continue with Facebook

        .other.skip(v-if='confirmation')
          button.btn-link.bold.xs-f-small.upper(type="button" v-on:click='skipPasswordCreate()') Skip

      #forgot-password.xs-12(v-if="view == 'forgot'")
        .title.text-center
          p.font-small.upper Forgot Password

        form#forgot_form(name='forgot_form' v-on:submit.prevent="forgotPassword()" novalidate)
          .error-container
            p.error(v-if="forgotError") {{forgotError}}

          .mr-input-wrap
            mrInput#forgot_email(v-model="$v.signInForm.email.$model" :label="'Email'" :inputType="'email'" :v="$v.signInForm.email" :autocomplete="'username'" required)

          button.mr-btn.btn-block.font-xsmall(type='submit' v-bind:disabled="$v.signInForm.email.$invalid" v-bind:class="{disabled: $v.signInForm.email.$invalid}" data-mr-ass="send-email") send email

        .remembered-password.text-center
          p Remembered your password?&nbsp;
            button.btn-link(v-on:click="view = 'signIn'") Log in

      #forgot-password-sms.xs-12(v-if="view == 'forgotSms'")
        .title.text-center
          p.upper.font-small Forgot Password
          p.font-xsmall.mt-30.mb-30 It looks like you might not be getting our password reset emails. If you do not receive one shortly, would you like to receive your password reset link via text message (SMS) using mobile number on file?
          button.mr-btn.btn-block.font-xsmall(v-on:click='sendPasswordResetSMS()') Send SMS

        .remembered-password.text-center.mt-10
          p.font-small Remembered your password?&nbsp;
            button.btn-link(v-on:click="view = 'signIn'") Log in

      #forgot-success.xs-12(v-if="view == 'emailSent'")
        .title
          p.upper.font-small Forgot Password
        .other
          p Your password reset link has been sent to
          b(data-mr-ass="forgot-password-msg") {{signInForm.email}}
          p
            button.btn-link(v-on:click="view = 'signIn'") Log in

      #forgot-success-sms.xs-12(v-if="view == 'smsSent'")
        .title
          p.upper.font-small Forgot Password
        .other
          p Your password reset link has been sent to your mobile number on file.
          p
            button.btn-link(v-on:click="view = 'signIn'") Log in

      #reset-password.xs-12(v-if="view == 'resetPassword'")
        .title.text-center
          p.font-small.upper Reset Password

        form#reset_form(name='reset_password_form' v-on:submit.prevent='resetPassword()' novalidate)
          .mr-input-wrap
            mrInput(v-model='$v.resetPasswordForm.email.$model' :v='$v.resetPasswordForm.email' :label="'Email'" :inputType="'email'" :autocomplete="'username'" required="true" :disabled="true")

          .error-container(v-if='!$v.resetPasswordForm.confirmNewPassword.sameAsNewPassword')
            p.error Password do not match!

          .mr-input-wrap
            mrInput(v-model='$v.resetPasswordForm.password.$model' :v="$v.resetPasswordForm.password" required="true" :dataMrAss="'new-password'")

          .mr-input-wrap
            mrInput(v-model='$v.resetPasswordForm.confirmNewPassword.$model' :v="$v.resetPasswordForm.confirmNewPassword" :label="'Confirm Password'" required="true" :dataMrAss="'confirm-new-password'")
          
          mrInput(:inputType="'hidden'" :name="'code'" :value='code')

          .captcha(v-show="showCaptcha == 'reset'")
            captcha(v-on:captcha-response="captchaResponse = $event")

          button.mr-btn.btn-block.font-xsmall(type='submit' v-bind:disabled='$v.resetPasswordForm.$invalid' v-bind:class="{disabled: $v.resetPasswordForm.$invalid}" :dataMrAss="'change-password'") change password

          .other
            p
              button.btn-link(type="button" v-on:click="view = 'forgot'") Resend password reset link

        .close(v-if='!confirmation && !checkout' v-on:click='control.open = false;')
          i.icon-x.xs-f-medium.md-f-xmedium.lg-f-medium.max-at-tweak
            
</template>

<script>
  import {
    getSignInData,
    verifyCipherStr,
    resetPassword,
    sendPasswordResetSMS,
    login,
    facebookLogin,
    createCustomer,
    forgotPassword
  } from "../services/vueCustomerSvc";
  import sentry from '../addSentry.js';
  import mrInput from './mrInput';
  import mrInputCheckbox from './mrInputCheckbox'; 

  const debounce = require("debounce");
  const { required, email, minLength, sameAs } = require("vuelidate/lib/validators");

  export default {
    name: 'mrSignIn',

    components: {
      mrInput,
      mrInputCheckbox,
    },

    props: {
      control: {
        default: () => {},
        type: Object
      },
      showBirthdayInput: {
        default: false,
        type: Boolean
      },
      authed: {
        default: false,
        type: Boolean
      },
      next: {
        type: String
      },
      startView: {
        type: String
      },
      checkout: {
        type: Boolean,
        default: false
      },
      confirmation: {
        type: Boolean,
        default: false
      }
    },

    data: function() {
      return {
        view: '',
        showInfo: '',
        showPassword: false,
        processing: false,
        signInForm: {
          email: '',
          password: ''
        },
        keepMeSignedIn: false,
        optInEmail: true,
        resetPasswordForm: {
          email: '',
          newPassword: '',
          confirmNewPassword: ''
        },
        showCaptcha: '',
        captchaResponse: null,
        birthdayMonth: null,
        birthdayDay: null,
        months: [
          {label: null, value: null},
          {label: '1', value: 1},
          {label: '2', value: 2},
          {label: '3', value: 3},
          {label: '4', value: 4},
          {label: '5', value: 5},
          {label: '6', value: 6},
          {label: '7', value: 7},
          {label: '8', value: 8},
          {label: '9', value: 9},
          {label: '10', value: 10},
          {label: '11', value: 11},
          {label: '12', value: 12}
        ],
        code: '',
        signInError: '',
        createError: '',
        forgotError: ''
      }
    },

    validations: {
      signInForm: {
        email: {
          required,
          email
        },
        password: {
          required,
          minLength: minLength(6)
        }
      },
      resetPasswordForm: {
        email: {
          required,
          email
        },
        newPassword: {
          required,
          minLength: minLength(6)
        },
        confirmNewPassword: {
          required,
          minLength: minLength(6),
          sameAsNewPassword: sameAs('resetPasswordForm.newPassword')
        }
      }
    },

    computed: {
      timedOut() {
        return this.authed && !this.$cookies.get(this.$root.MRConfig.timeoutCookie);
      },

      nextUrl() {
        return decodeURIComponent(this.next || this.$root.urlParams.next || window.location);
      },

      days() {
        var days = [{label: null, value: null}];
        var month = this.birthdayMonth || 1;

        var numDays = new Date(1896, month, 0).getDate();
        for (var x = 1; x <= numDays; x++) {
          days.push({label: '' + x, value: x});
        }

        if (this.birthdayDay > numDays) {
          this.birthdayDay = null;
        }

        return days;
      },

      birthday() {
        if (this.birthdayMonth && this.birthdayDay) {
          var month = ('0' + this.birthdayMonth).slice(-2);
          var day = ('0' + this.birthdayDay).slice(-2);
          return month + '/' + day + '/1896';
        } else {
          return null;
        }
      }
    },

    asyncComputed: {
      fbAuthed: function() {
        return this.customerInfo && this.customerInfo.authed && this.customerInfo.fbObj;
      }
    },

    methods: {
      toggleInfo: function(name) {
        this.showInfo = this.showInfo != name ? name : '';
      },

      signIn: function() {
        var self = this;
        if (self.processing) {
          return;
        }
        self.processing = true;
        login({
          email: self.signInForm.email,
          password: self.signInForm.password,
          keepMeSignedIn: self.keepMeSignedIn,
          captchaResponse: self.captchaResponse,
          code: self.code
        }).then(() => {
          self.processing = false;
          location.href = self.nextUrl;
        }).catch(err => {
          var error = err.response;
          self.processing = false;
          if (error.data.code == 'CAPTCHA') {
            self.showCaptcha = 'login';
            self.captchaResponse = null;
          }
          self.signInError = error.data.message;
        });
      },

      createAccount: function() {
        var self = this;
        if (self.processing) {
          return;
        }
        self.processing = true;
        var payload = {
          email: self.signInForm.email,
          password: self.signInForm.password,
          confirm: self.signInForm.password,
          url: self.nextUrl,
          email_source: 'website',
          optInEmail: self.optInEmail,
          birthday: self.birthday,
          captchaResponse: self.captchaResponse
        };

        if (self.code) { // reset password and sign in
          resetPassword({
            account_email: self.signInForm.email,
            accountPassword: self.signInForm.password,
            accountPasswordConfirm: self.signInForm.password,
            code: self.code,
            captchaResponse: self.captchaResponse,
            update: payload
          }).then(() => {
            self.processing = false;
            self.signIn();
          }).catch(err => {
            self.processing = false;
            var error = err.response;
            if (error.data.code == 'CAPTCHA') {
              self.showCaptcha = 'create';
            }
            self.createError = error.data.message;
          });
        } else { // create customer
          createCustomer(payload).then(() => {
            self.processing = false;
            location.href = self.nextUrl;
          }).catch(err => {
            self.processing = false;
            var error = err.response;
            if (error.data.code == 'CAPTCHA') {
              self.showCaptcha = 'create';
            }
            self.createError = error.data.message;
            if (error.data.validation) {
              var firstKey = Object.keys(error.data.validation)[0];
              self.createError = error.data.validation[firstKey];
            }
          });
        }
      },

      forgotPassword: function() {
        var self = this;
        if (this.processing) {
          return;
        }
        self.processing = true;

        forgotPassword({
          email: self.signInForm.email
        }).then(() => {
          self.processing = false;
          self.view = 'emailSent';
        }).catch(err => {
          self.processing = false;
          var error = err.response;
          var doRedirect = false;
          var errorMessage = '';

          if (err.data) {
            if (err.data.mess == 'Invalid Email') {
              doRedirect = true;
              errorMessage = error.data.message + ', redirecting to support page, one moment.';
            }

            if (error.data.code == 'UNSUBSCRIBED') {
              this.$store.dispatch('notify', {
                class: 'warn',
                message: 'It looks like you might not be getting our password reset emails. If you do not receive one shortly please contact Color Crew for assistance.',
                time: 10000
              });
            }

            if (error.data.code == 'UNSUBSCRIBED_HAS_MOBILE') {
              self.view = 'forgotSms';
            }
          }

          self.forgotError = errorMessage;

          if (doRedirect) {
            setTimeout(() => {
              window.location = '/support';
            }, 4000);
          }
        });
      },

      sendPasswordResetSMS: function() {
        var self = this;
        sendPasswordResetSMS({
          email: self.signInForm.email
        }).then(res => {
          self.view = 'smsSent';
        }).catch(() => {
          this.$store.dispatch('notify', {
            class: 'error',
            message: 'Something went wrong and might not have been able to send SMS, try again or please contact Color Crew for assistance.',
            time: 10000
          });
        });
      },

      resetPassword: function() {
        var self = this;
        if (self.processing) {
          return;
        }
        self.processing = true;

        resetPassword({
          account_email: self.resetPasswordForm.email,
          accountPassword: self.resetPasswordForm.newPassword,
          accountPasswordConfirm: self.resetPasswordForm.confirmNewPassword,
          code: self.code,
          captchaResponse: self.captchaResponse
        }).then(() => {
          self.processing = false;
          self.signInForm.password = self.resetPasswordForm.newPassword;
          self.resetPasswordForm.newPassword = '';
          self.resetPasswordForm.confirmNewPassword = '';
          self.captchaResponse = null;
        }).catch(err => {
          self.processing = false;
          var error = err.response;
          if (error.data.code == 'CAPTCHA') {
            self.showCaptcha = 'reset';
          } else {
            self.resetPasswordForm.newPassword = '';
            self.resetPasswordForm.confirmNewPassword = '';
          }
          this.$store.dispatch('notifyError', error.data.code);
        });
      },

      facebookSignIn: function() {
        var self = this;
        var FB = window.FB;
        if (!FB) {
          setTimeout(self.facebookSignIn, 300);
          return;
        }

        FB.login(function() {
          var fields = [
            'id',
            'email',
            'name',
            'first_name',
            'last_name',
            'middle_name',
            'gender',
            'birthday',
            'hometown',
            'link',
            'locale',
            'location',
            'timezone',
            'updated_time',
            'verified',
          ];
          FB.api('/me', { fields: fields.join(',') }, function(fbRes) {
            FB.getLoginStatus(function(statusRes) {
              if (statusRes.authResponse.accessToken && statusRes.authResponse.expiresIn) {
                fbRes.accessToken = statusRes.authResponse.accessToken;
                fbRes.accessTokenExpires = statusRes.authResponse.expiresIn;
              }

              facebookLogin(fbRes).then(res => {
                if (res.data.success == 0 && res.data.err == 'bad-facebook-data') {
                  this.$store.dispatch('notify', {
                    class: 'error',
                    message: 'There was a problem retrieving your data from facebook. Please submit an email and password to log in or create an account.',
                    time: 15000
                  });
                  return;
                }
                location.href = self.nextUrl;
              });
            });
          });
        }, {
          scope: [
            'email'
          ].join(',')
        });
      }
    },

    mounted() {
      var self = this;
      var resetPassword = window.resetPassword || {};
      self.code = resetPassword.code || self.$root.urlParams.code;
      self.view = self.view = self.startView || resetPassword.view || self.$root.urlParams.view || 'signIn';
      self.signInForm.email = self.$root.urlParams.email || '';
      self.showOptIn = !self.signInForm.email;

      if (self.code) {
        verifyCipherStr({ code: self.code }).then(res => {
          self.signInForm.email = res.data.email;
        }).catch((err, more) => {
          this.$store.dispatch('notifyError', 'Invalid or expired password reset link.');
          self.view = 'forgot';
        });
      }

      if (self.view !== 'resetPassword' && self.view !== 'setPassword') {
        getSignInData().then(res => {
          if (res.data.email) {
            self.signInForm.email = res.data.email;
            self.showOptIn = false;
          }
        }).catch(err => {
          // send to sentry
          sentry.withScope(scope => {
            scope.setTag('vueComponent', 'mrSignIn');
            sentry.captureException(err);
          });
        });
      }
    }
  }
</script>

<style scoped lang="stylus">

.mr-sign-in
  // Generic classes
  .sign-in-wrap
    margin 0 auto
    background-color #fff
    position relative
    padding 20px 60px
    padding-bottom 60px
    margin-top 30px
    border 1px solid #ddd
    border-radius 3px
    box-shadow(0px 1px 5px #ddd)
    max-width 500px
    min-height 500px
    overflow hidden

    .mr-input-wrap
      padding-top 10px
      padding-bottom 15px
      >>> .mr-input
        margin 0 0
         
    .checkbox
      padding-left 0
      position relative
      display inline-block
      margin-bottom 15px

      > *
        display inline-block
      
      >>> label
            font-size font-size-xsmall
            display flex

            .mr-checkbox
              width 19px
              height 19px
              flex-shrink 0

    .captcha
      text-align center
      margin-bottom 15px
      captcha
        display inline-block

    .popup-info
      margin-bottom 10px
      text-align left
      position relative
      padding-bottom 20px

      .hide-info
        position absolute
        right 5px
        bottom 0

    .other
      margin 40px auto
      border-top 1px solid color-gray-med
      text-align center
      padding-top 20px

      &.other-checkout
        margin-bottom 0

      p
        display block
        margin-top 10px
        
      &.skip
        margin-top 0px

    .facebook-sign-in
      color fb-color
      span
        line-height 24px
        display inline-block
        vertical-align top

      .icon-facebook
        color color-white
        background-color fb-color
        border-radius 3px
        
        &:before
          margin-right 0
          vertical-align middle

      .close
        position absolute
        top 0.5em
        right 0.5em

    // View specific
    #sign-in-top
      margin-bottom 10px
      
      button
        position relative
        padding 1em 0
        color #cac7c7
        font-family font-family-primary-light
        
        &:after
          content ''
          position absolute
          left 0
          right 0
          bottom 0
          height 1px
          background-color #cac7c7
                  
        &.selected
          color color-mr-purple
          font-family font-family-primary-semi-bold
          
          &:after
            height 5px
            background-color color-mr-purple

    #sign-in
      .not-you-wrap
        padding-top 1.5em
   
      .or
        position relative
        margin 20px auto
        border-top 1px solid #dbdbdb
        text-align center

        p
          color #dbdbdb
          display block
          width 40px
          margin 0 auto
          background-color #fff
          margin-top -8px

    #sign-up
      .birthday
        .info-toggle
          display block
          padding-bottom 10px
          
        .birthday-input
          display inline-block
          vertical-align top
          width 50%
          margin-bottom 15px
          
          .customDropdown
            width 100%
            
            .option.expanded
              max-height 235px
          
          &:first-child
            padding-right 7px
            
          &:last-child
            padding-left 7px
      
      .opt-in
        margin-top 10px

    #forgot-password
      padding 15px
        
    #reset-password
      .error-container
        margin-top 10px
        
  // Breakpoint specific
  @media mq-mobile
    .sign-in-wrap
      padding 20px 5%
      width 100%
      margin-top 0
      border none
      box-shadow(none)

</style>
